<template>
  <div>
    <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div>
    <br>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <div id="my-table-id">
      <v-data-table :headers="headers" :items="year_list" class="elevation-1 mytable" :search="search">
        <template v-slot:top>
          <v-toolbar class="toolbar" flat color="white">
            <v-toolbar-title>Year</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-row dense>
            <v-col cols="12" sm="3" md="3">
              <!-- <v-btn color="success" outlined rounded> -->
              <!-- v-if="year_list.length != 0" -->
              <!-- <download-excel
                class="mr-2 pb-3 pt-2"
                :data="year_list"
                :fields="table_fields"
                worksheet="PayRoll_Year"
                name="PayRoll_Year.xls"
              >
                <v-icon dark>mdi-file-excel</v-icon> Export
              </download-excel>
            </v-btn> -->
              <v-btn rounded color="success" outlined @click="fnExcelReport('my-table-id', 'Year')"
                :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn>
            </v-col>
            <v-col sm="6" md="4" cols="12">
              <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
              </v-text-field>
            </v-col>
            <span style="width: 20px"></span>
            <v-dialog v-model="dialog" max-width="500px">
              <template v-slot:activator="{ on }">
                <v-btn color="mb-2 button" v-on="on">Add Year</v-btn>
              </template>
              <v-card>
                <v-form v-model="valid">
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field v-model="editedItem.name" persistent-hint :hint="
                            editedIndex == -1
                              ? 'For example :: 2020-2021'
                              : 'For example :: 2020-2021'
                          " label="Enter Year" :rules="[(v) => !!v || 'required']" rounded outlined dense
                            type="number">
                          </v-text-field>
                        </v-col>
                        <!-- <v-col cols="12" sm="12" md="12">
                    <v-text-field v-model="editedItem.display_name" 
                    persistent-hint
                    :hint="editedIndex==-1?'For example :: Jan,Feb':'For example :: Jan,Feb'"
                    label="Enter Display Name"
                    :rules="[v => !!v || 'required']"
                    rounded
                    outlined
                    dense
                    >
                    </v-text-field>
                  </v-col>     -->

                        <v-col cols="12" sm="12" md="12">
                          <v-checkbox v-model="editedItem.isActive" color="success" label="Is Active?"></v-checkbox>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="mb-2 button" text @click="close">Cancel</v-btn>
                    <v-btn color="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <template v-slot:item.isactive="{ item }">
          <span v-if="item.isactive">
            <v-icon small class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
          </span>
          <span v-else>
            <v-icon small class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
          </span>
        </template>

        <template v-slot:item.action="{ item }">
          <div>
            <v-avatar style="" size="25" class="edit-avatar">
              <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
            </v-avatar>
          </div>
        </template>
      </v-data-table>
    </div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
  components: {
    Breadcrumbs,
  },

  data: () => ({
    valid: false,
    extraBreadcrumbItems: [
      { text: "Year", disabled: true, href: "" },

    ],
    breadcrumbClass: "breadcrumb-style1",
    overlay: false,
    errorMsg: {
      castId: false,
    },
    snackbar_msg: "",
    color: "",
    snackbar: false,
    search: "",
    dialog: false,
    headers: [
      {
        text: "Year",
        align: "left",
        sortable: false,
        value: "name",
      },
      {
        text: "Is Active?",
        align: "left",
        sortable: false,
        value: "isactive",
      },
      { text: "Actions", value: "action", sortable: false },
    ],
    table_fields: {
      Year: "name",
      "Is Active?": "isactive",
    },
    year_list: [],
    editedIndex: -1,
    editedItem: {
      yearId: "",
      name: "",
      display_name: "",
      isActive: true,
    },
    defaultItem: {
      yearId: "",
      name: "",
      display_name: "",
      isActive: true,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Year" : "Edit Year";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    overlay(val) {
      val = () => {
        this.overlay = false;
      };
    },
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    fnExcelReport(id, name) {
  let tab_text = `<table border='1px'>
    <tr>
      <th>Year</th>
      <th>Is Active ?</th>
      
    </tr>`;

  this.year_list.forEach((item, index) => {
    tab_text += `
    <tr>
      <td>${item.name}</td> 
      <td>${item.isActive ? 'Active' : 'Inactive'}</td>
    </tr>`;
  });

  tab_text += '</table>';

  const blob = new Blob([tab_text], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
  });
  const filename = name + '_' + parseInt(Math.random() * 10000000000) + '.xls';

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    // For IE
    window.navigator.msSaveOrOpenBlob(blob, filename);
  } else {
    // For modern browsers
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
  }
},
    initializeErrorMsgFalse() {
      this.errorMsg.castId = false;
    },

    onLoad() {
      this.overlay = true;
      axios
        .post("/Payroll/getYearList")
        .then((res) => {
          if (res.data.msg == "200") {
            if ((this.load = true)) {
              this.overlay = false;
              this.year_list = res.data.year_list;
              //window.alert(JSON.stringify(this.year_list))
            }
          } else {
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          var overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },

    editItem(item) {
      this.editedIndex = this.year_list.indexOf(item);
      this.dialog = true;
      this.editedItem.name = item.name;
      this.editedItem.display_name = item.displayName;
      this.editedItem.isActive = item.isactive;
      this.editedItem.yearId = item.id;
    },

    // deleteItem (item) {
    //   const index = this.language_super_master_list.indexOf(item)
    //   confirm('Are you sure you want to delete this item?') && this.language_super_master_list.splice(index, 1)
    // },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        if (this.isValidated()) {
          axios
            .post("/Payroll/editYear", this.editedItem)
            .then((res) => {
              if (res.data.status.code == "200") {
                Object.assign(
                  this.year_list[this.editedIndex],
                  this.editedItem
                );
                this.showSnackbar("#4caf50", "Year Updated Successfully..."); // show snackbar on success
                this.onLoad();
              } else if (res.data.status.code == "NA") {
                this.showSnackbar("#b71c1c", "Year Already Present!!!"); // show snackbar on error
              }
            })
            .catch((error) => {
              window.console.log(error);
            });
          this.close();
        }
      } else {
        //window.alert(JSON.stringify(this.editedItem))
        axios
          .post("/Payroll/saveYear", this.editedItem)
          .then((res) => {
            if (res.data.status.code == "200") {
              this.showSnackbar("#4caf50", "Year Added Successfully..."); // show snackbar on success
              this.onLoad();
            } else if (res.data.status.code == "NA") {
              this.showSnackbar("#b71c1c", "Year Already Present!!!"); // show snackbar on error
            }
          })
          .catch((error) => {
            window.console.log(error);
          });
        this.close();
      }
    }, // end of save()

    isValidated() {
      if (this.editedItem.yearId) {
        return true;
      } else {
        if (!this.editedItem.yearId) {
          this.errorMsg.yearId = true;
        }

        return false;
      }
    }, // .....end of isValidated()
  },
};
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size {
  font-size: 20px;
}
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon {
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover {
  color: white;
}
</style>